import { ATTACHED_LEVEL_NAME } from "../external-audit/constants";

export const assignedToEnums = {
  caseProcessManager: "CPM",
  designatedMdauditUser: "DMU",
  externalUser: "EU",
  externalUserGroup: "EG",
  overrideAuditor: "OA",
  primaryAuditor: "PA",
  processManager: "PM",
  qaReviewer: "QR",
  taskGroup: "TG",
};

export const workflowModuleTypeEnums = {
  externalAuditWorkflow: "EAW",
  internalAuditWorkflow: "IAW",
  maintenanceWorkflow: "MW",
};

export const WORKFLOW_CONFIG_MAP = {
    [workflowModuleTypeEnums.maintenanceWorkflow]: {
      allowedUserTypes: [
        assignedToEnums.designatedMdauditUser,
        assignedToEnums.externalUser
      ],
      restrictedUserTypes: undefined, 
      allowDuplicateInd: true,
      defaultUserType: null,
    },
    [workflowModuleTypeEnums.externalAuditWorkflow]: {
      allowedUserTypes: [
        assignedToEnums.processManager,
        assignedToEnums.externalUser,
        assignedToEnums.designatedMdauditUser,
        assignedToEnums.externalUserGroup,
        assignedToEnums.taskGroup,
        assignedToEnums.caseProcessManager
      ],
      levelConfigs: {
        [ATTACHED_LEVEL_NAME.ExternalAuditCase]: {
        extraRestrictedTypes: [],
          defaultUserType: assignedToEnums.caseProcessManager
        },
        [ATTACHED_LEVEL_NAME.ExternalAudit]: {
          extraRestrictedTypes: [assignedToEnums.caseProcessManager], 
          defaultUserType: assignedToEnums.processManager
        }
      },
      restrictedUserTypes: undefined,
      allowDuplicateInd: false,
      defaultUserType: assignedToEnums.processManager
    },
    DEFAULT: {
      allowedUserTypes: undefined,
      restrictedUserTypes: [
        assignedToEnums.processManager,
        assignedToEnums.externalUserGroup,
        assignedToEnums.taskGroup
      ],
      allowDuplicateInd: false,
      defaultUserType: null
    }
  };
  
export const DEFAULT_WORKFLOW_CONFIG = {
    allowedUserTypes: null, 
    restrictedUserTypes: [
      assignedToEnums.processManager,
      assignedToEnums.caseProcessManager,
      assignedToEnums.externalUserGroup,
      assignedToEnums.taskGroup,
    ],
    allowDuplicateInd: false,
    defaultUserType: null,
  };
